module.exports = __webpack_public_path__ + "static/media/img-login-upperright@2x.9b2456ce.png";